<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>workspace_premium</mat-icon></div>
      <div>
        <h2 class="ud-title">Upgrade to PlanaCan Premium</h2>
        <div class="ud-subtitle">Unlock more capacity for your growing team</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="ud-close" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <div class="ud-body rn-body">
    @if (attemptedAction !== 'upgrade') {
      <div class="rn-limit">
        <div class="rn-limit-icon"><mat-icon>info</mat-icon></div>
        <div>
          <strong>You’ve reached the free {{ resourceName }} limit</strong>
          <p>Your current plan includes up to {{ freeLimit }} {{ resourceName }}. Upgrade to keep growing without removing existing data.</p>
        </div>
      </div>
    }

    <div class="rn-benefits" [class.rn-benefits-single]="attemptedAction !== 'upgrade'">
      @if (attemptedAction === 'harvestAdd' || attemptedAction === 'upgrade') {
        <div class="rn-benefit"><mat-icon>local_florist</mat-icon><div><h3>More harvests</h3><p>Plan and track multiple grow cycles with unique schedules and identifiers.</p></div></div>
      }
      @if (attemptedAction === 'templateAdd' || attemptedAction === 'upgrade') {
        <div class="rn-benefit"><mat-icon>account_tree</mat-icon><div><h3>More workflows</h3><p>Build specialized procedures for strains, teams, and repeatable processes.</p></div></div>
      }
      @if (attemptedAction === 'userAdd' || attemptedAction === 'upgrade') {
        <div class="rn-benefit"><mat-icon>groups</mat-icon><div><h3>Grow your team</h3><p>Add employees, assign work, and control access with custom roles.</p></div></div>
      }
    </div>

    <div class="rn-trial"><mat-icon>verified</mat-icon><span><strong>7-day trial included.</strong> Explore Premium before committing.</span></div>
  </div>

  <div class="ud-footer">
    <button mat-button mat-dialog-close class="ud-btn-ghost">Not now</button>
    <app-upgrade-btn [trialDays]="7" (successfulUpgrade)="successfulUpgrade()"></app-upgrade-btn>
  </div>
</div>
